import styled from "styled-components";
import {
  CloseButton,
  ModalBody,
  ModalContent,
  ModalHeader,
  ModalOverlay,
} from "./PrivacyPolicyModal";
export const EmailBlockModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <ModalOverlay onClick={onClose}>
      <SmallModalContent onClick={(e) => e.stopPropagation()}>
        <ModalHeader>
          <h2>이메일주소 무단수집 거부</h2>
          <CloseButton onClick={onClose}>×</CloseButton>
        </ModalHeader>
        <ModalBody>
          <EmailContent>
            <h3>회원의 이메일주소 무단수집 거부</h3>
            <p>
              우리 "관세법인 에이원" 회원에게 무차별적으로 보내지는 타사의
              메일을 차단하기 위해, 본 웹사이트에 게시된 이메일 주소가 전자우편
              수집 프로그램이나 그 밖의 기술적 장치를 이용하여 무단으로 수집되는
              것을 거부하며, 이를 위반 시 정보통신망법에 의해 형사처벌됨을
              유념하시기 바랍니다.
            </p>
            <DateText>게시일 2020년 02월 17일</DateText>
          </EmailContent>
        </ModalBody>
      </SmallModalContent>
    </ModalOverlay>
  );
};

const SmallModalContent = styled(ModalContent)`
  max-width: 600px;
`;

const EmailContent = styled.div`
  line-height: 1.8;
  color: #374151;

  h3 {
    font-size: 1.3rem;
    margin-top: 0;
    margin-bottom: 1.5rem;
    color: #1f2937;
  }

  p {
    margin-bottom: 2rem;
    font-size: 1rem;
  }
`;

const DateText = styled.p`
  text-align: right;
  font-weight: 600;
  color: #6b7280;
  margin-top: 2rem;
`;
